<template>
    <PageSidebar>
        <template #sidebarTitle>
            <div class="space-x-3">
                <ButtonSecondaryIconSm @click="handleQuit">
                    <ArrowLeftIcon />
                </ButtonSecondaryIconSm>
                <span>{{
                    mode === "create"
                        ? $t("legal.navigation.add_category")
                        : $t("legal.navigation.edit_category")
                }}</span>
            </div>
        </template>
        <template #sidebarMain>
            <div class="p-6">
                <FormInput id="categoryName" :title="$t('shared.title')" v-model="category.name" />
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton
                @save="$emit('save')"
                :disabled="!isDirty"
                :ctaDisabled="$t('shared.save')"
            />
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { ButtonSecondaryIconSm } from "@easy/ui/buttons";
import { ArrowLeftIcon } from "@easy/ui/icons";
import { FormInput } from "@easy/ui/forms";
import { useSaveOrDropModal } from "@/store/useSaveOrDropModal";
import { useIsDirty } from "@/shared/utils/forms/useIsDirty";
import cSaveButton from "@/shared/components/cSaveButton.vue";
import { useFocusOnQueryField } from "@/shared/utils/forms/useFocusOnQueryField";

export default {
    components: {
        PageSidebar,
        ButtonSecondaryIconSm,
        ArrowLeftIcon,
        FormInput,
        cSaveButton,
    },
    props: {
        category: {
            type: Object,
            required: true,
        },
        backupData: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            required: true,
        },
    },
    emits: ["save", "cancel"],
    setup(props) {
        useFocusOnQueryField();
        const { isDirty } = useIsDirty(props.backupData, props.category);
        const { askToConfirmIfNeeded } = useSaveOrDropModal();
        return {
            isDirty,
            askToConfirmIfNeeded,
        };
    },
    methods: {
        async handleQuit() {
            const result = await this.askToConfirmIfNeeded({
                showModal: this.isDirty,
                onConfirmChanges: () => this.$emit("save"),
            });
            if (!result) {
                this.$emit("cancel");
            }
        },
    },
};
</script>
